<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import Store from '@/store'
import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'
import find from 'lodash/find'

import TransitionWrapper from '@/layout/wrappers/transition-wrapper'
import AppearanceWrapper from '@/layout/wrappers/appearance-wrapper'

import ScrollMarker from '@/components/scroll-marker'
import Description from './description'
import Partners from './partners'
import Awards from './awards'
import TheFooter from '@/layout/the-footer'

export default {

  name: 'AboutPage',

  components: {
    TransitionWrapper,
    AppearanceWrapper,
    ScrollMarker,
    Description,
    Partners,
    Awards,
    TheFooter
  },

  computed: {
    $content () {
      return this.$store.state.pages.landings.about
    },

    $description () {
      return find(this.$content.widgets, { type: 'Description' })
    },

    $partners () {
      return find(this.$content.widgets, { type: 'BoxList' })
    },

    $awards () {
      return find(this.$content.widgets, { type: 'List' })
    }
  },

  beforeRouteEnter: async (to, from, next) => {
    Store.commit('startLoading')
    const page = await Store.dispatch('pages/fetchLanding', 'about')
    Store.commit('endLoading')
    next()
  },

  beforeRouteUpdate: async (to, from, next) => {
    if (from.params.lang === to.params.lang) {
      next()
      return
    }

    Store.commit('startLoading')
    const page = await Store.dispatch('pages/fetchLanding', 'about')
    Store.commit('endLoading')
    next()
  },

  created(){
    this.setTitle();
  },

  methods: {

    setTitle(){
      let title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },

    enter (el, done) {
      const tl = new Line({ onComplete: () => done })

      tl.from(this.$refs.background, 1, {
        y: -65,
        scaleY: 0,
        ease: Power1.easeOut
      })

      tl.from(this.$refs.content, 1, {
        autoAlpha: 0,
        y: -40,
        ease: Power1.easeOut
      }, 0.1)

      if (this.$refs.image) {
        tl.from(this.$refs.image, 1, {
          autoAlpha: 0,
          ease: Power1.easeOut,
          // onUpdate: () => {
          //   const y = this.$refs.image.style.opacity * 100

          //   Tween.set(this.$refs.image, {
          //     clipPath: `polygon(0% 0%, 100% 0%, 100% ${y}%, 0% ${y}%)`
          //   })
          // }
        })

        // tl.from(this.$refs.image, 1, {
        //   autoAlpha: 0,
        //   ease: Power1.easeOut
        // })
      }
    },

    leave (el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done()
      } else {
        Tween.to(el, 0.5, {
          autoAlpha: 0,
          ease: Power1.easeOut,
          onComplete: done
        })
      }
    },

    scroll () {
      const bb = this.$refs.description.$el.getBoundingClientRect()

      const offset = bb.top - ((this.$store.state.app.window.height - bb.height) / 2)
      const scroll = this.$store.state.app.window.scroll + offset

      Tween.to(window, 1, {
        scrollTo: scroll,
        ease: Power1.easeInOut
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.about-page
  .about-page__content

    .intro
      .intro-wrapper
        .intro-container
          .intro-background(ref="background")
          .intro-video
          .intro-content(ref="content")
            img.intro-logo(src="../../assets/aurocraft-logo.svg")
            .intro-description(v-if="$content.description" v-html="$content.description")
          transition-wrapper(:appear="true" appear-delay="0.5")
            scroll-marker.intro-scroll(@click="scroll")
      .intro-image(v-if="$content.media && $content.media.image" ref="image"): img(:src="$content.media.image.url" alt="image")

    appearance-wrapper
      description(v-if="$description", :$content="$description" ref="description")

    appearance-wrapper
      partners(v-if="$partners", :$content="$partners")

    appearance-wrapper
      awards(v-if="$awards", :$content="$awards")

  the-footer

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.intro-wrapper
  width 100vw
  height 100vh
  padding 45px
  +laptop()
    padding 50px
  +mobile()
    padding 12px
    height 90vh

.intro-container
  z-index 1
  position relative
  display flex
  justify-content center
  align-items center
  width 100%
  height 100%

.intro-background
  z-index 1
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  background-color blue
  transform-origin top

  & ~ *
    z-index 2
    position relative

.intro-video
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  z-index 0

.intro-content
  position relative
  display flex
  flex-direction column
  align-items center
  width 100%
  max-width 550px
  padding 0 55px
  +devices()
    max-width 460px

.intro-logo
  max-width 423px
  min-height: 44px
  width 100%

.intro-description
  font-weight 300
  font-size 26px
  line-height 34px
  color white
  font-family 'Helvetica'
  text-align center
  padding-top 13px

  +mobile()
    font-size 17px
    line-height 25px

  &:before
    content '–'
    display block

.intro-image
  width 100%
  height 652px
  margin-top -185px
  overflow hidden

  img
    width 100%
    height 100%
    object-fit cover

.intro-scroll
  position absolute
  left 0
  right 0
  bottom 0
  margin 0 auto

</style>



// WEBPACK FOOTER //
// index.vue?73227f44